import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import televedaPurpleLogo from '../../assets/brand/Televeda_Logo_Wisdom.png';
import GetHelpModal from '../getHelpModal/GetHelpModal';
import { openAudioEyeMenu } from '../navigation/audioeyeScript';

const LEGAL_URL = 'https://www.televeda.com/legal-privacy-statement';

function normalizeLanguage(language: string | undefined): 'en' | 'es' {
  return language?.startsWith('es') ? 'es' : 'en';
}

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [isHelpModalOpened, setIsHelpModalOpened] = useState(false);
  const [language, setLanguage] = useState<'en' | 'es'>(() => normalizeLanguage(i18n.language));

  useEffect(() => {
    setLanguage(normalizeLanguage(i18n.language));
  }, [i18n.language]);

  function handleLanguageChange(nextLanguage: string) {
    if (!nextLanguage || nextLanguage === language) return;
    setLanguage(normalizeLanguage(nextLanguage));
    void i18n.changeLanguage(nextLanguage);
  }

  return (
    <>
      {/* Deliberately not `hidden-sm`: the footer holds the language selector, which
          mobile users need just as much as desktop ones. */}
      <footer className="container site-footer">
        <hr className="site-footer__divider" />
        <div className="site-footer__row">
          <div className="site-footer__links">
            <a href={LEGAL_URL} className="site-footer__link" target="_blank" rel="noreferrer">
              {t('LEGAL')}
            </a>
            <button
              type="button"
              className="anchor site-footer__link"
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              onClick={openAudioEyeMenu}
            >
              {t('ACCESSIBILITY')}
            </button>
          </div>

          <div className="site-footer__brand">
            <p className="site-footer__made-with">
              {t('MADE_WITH')} <i className="fa-jelly fa-heart site-footer__heart" aria-hidden />{' '}
              {t('BY').toLowerCase()}
            </p>
            <div className="site-footer__logo-wrap">
              <img className="site-footer__logo" src={televedaPurpleLogo} alt="Televeda" />
            </div>
          </div>

          <div className="site-footer__actions">
            <div className="site-footer__language">
              <select
                className="form-control has-feedback"
                aria-label={t('LANGUAGE')}
                value={language}
                onChange={(e) => handleLanguageChange(e.target.value)}
              >
                <option value="en">English</option>
                <option value="es">Español</option>
              </select>
              <i
                aria-hidden="true"
                className="fa-jelly-duo fa-regular fa-angle-down form-control-feedback"
              />
            </div>
            <button
              className="btn btn-primary btn-outline"
              type="button"
              onClick={() => setIsHelpModalOpened(true)}
            >
              {t('GET_HELP')}
              <i className="fa-jelly-duo fa-regular fa-circle-question" aria-hidden />
            </button>
          </div>
        </div>
      </footer>
      <GetHelpModal isOpen={isHelpModalOpened} onClose={() => setIsHelpModalOpened(false)} />
    </>
  );
};

export default Footer;
